import React from 'react';
import { useQuery } from '@apollo/client';
import { NavLink } from 'react-router-dom';
import { List } from 'semantic-ui-react';
import { MY_LISTS } from '../../queries/list';
import Security from '../../utils/Security';

const NavLinks = () => {
  const { data } = useQuery(MY_LISTS);
  const firstListId = data?.myLists?.[0]?.id;
  const canUseChat = Security.isSuperUser() || Security.isDecibio();

  return (
    <List horizontal className="nav-link">
      <List.Item>
        <NavLink to="/home" exact>Home</NavLink>
      </List.Item>
      <List.Item>
        <NavLink to="/projects">Projects</NavLink>
      </List.Item>
      {canUseChat && (
        <List.Item>
          <NavLink to="/ai-chat">
            AIChat
            <sup className="beta">beta</sup>
          </NavLink>
        </List.Item>
      )}
      {firstListId && (
        <List.Item>
          <NavLink to={`/lists/${firstListId}`}>Lists</NavLink>
        </List.Item>
      )}
      <List.Item>
        <NavLink to="/schedule">My Schedule</NavLink>
      </List.Item>
    </List>
  );
};

export default NavLinks;
